<template>
  <motlet :options="motletOptions">
    <template v-slot:content="{ props }">
      <bar-chart :settings="settings" :motlet="props.motlet" />
    </template>
  </motlet>
</template>

<script>
import { bytes } from '@/utils/formatter';
import barChartable from './barChartable';

export default {
  mixins: [barChartable],
  data() {
    return {
      motletOptions: {
        id: 'detailview/java/jvmMemory/PermGenBar',
        title: this.$t('dv.title.perm.gen'),
        monitor: {
          monitorCode: 'C_JAVA_MEM',
          categoryField: 'memNm',
          points: 30,
        },
        settings: { chart: { use: false } },
        dataParam: {
          memKind: 'PG',
        },
      },
    };
  },
  methods: {
    getSeries() {
      return this.descendants
        .filter(descendant => descendant.active)
        .map(descendant => {
          return {
            label: {
              show: true,
              position: 'top',
              color: descendant.color,
              formatter: param => bytes(param.data[param.seriesIndex + 1]),
            },
          };
        });
    },
    getSettings() {
      return {
        chart: {
          xAxis: {
            axisLabel: {
              show: false,
            },
          },
          yAxis: {
            show: false,
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
          },
          grid: {
            top: '15px',
            bottom: '0px',
            left: '5px',
            right: '5px',
          },
          series: this.getSeries(),
        },
      };
    },
  },
  watch: {
    timestamp(value) {
      this.fetchData(value);
    },
  },
};
</script>
